import { useId } from 'react';

import { cn } from '@/lib/utils';

export interface PatientReportProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size applied to both width and height
   */
  size?: number;
  /**
   * Optional explicit width (overrides size)
   */
  width?: number;
  /**
   * Optional explicit height (overrides size)
   */
  height?: number;
  /**
   * Stroke or fill color (defaults to brand navy).
   */
  color?: string;
}

export function PatientReport({
  size = 18,
  width,
  height,
  color = '#001D74',
  className,
  ...props
}: PatientReportProps) {
  const w = width ?? size;
  const h = height ?? size;
  const maskId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 24 24"
      fill="none"
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden="true"
      {...props}
    >
      <defs>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="black" />
          <g transform="rotate(-45 11.5 12)">
            <rect x="4.5" y="9.2" width="14" height="4.6" rx="2.3" fill="white" />
            <rect x="6.8" y="10.4" width="9.4" height="2.2" rx="1.1" fill="black" />
          </g>
        </mask>
      </defs>

      <g transform="translate(0 -1.2)">
        <g mask={`url(#${maskId})`}>
          <rect width="24" height="24" fill={color} />
        </g>
        <g transform="rotate(-45 11.5 12)">
          <path d="M3.7 11.5 L6.2 14 L6.2 9 Z" fill={color} />
        </g>
        <rect
          x="17.5"
          y="3"
          width="4.2"
          height="3.2"
          rx="1.2"
          transform="rotate(45 17.5 3)"
          fill={color}
        />
      </g>
      {/* Base platform underneath the pencil */}
      <rect x="2.8" y="17.3" width="18.4" height="4.2" rx="0.8" fill={color} />
    </svg>
  );
}
